import { _sharedActionsConstantsToc, _sharedActionsToc } from "@/shared/store/toc/actions";

export const tocActionsConstants = _sharedActionsConstantsToc;
export const tocActions = _sharedActionsToc;
